export default "/images/logo.png?3961b8360459306aea700ec7cc47a089";